import { getEnvVariable } from '@appcharge/shared-ui';
import mixpanel, { Dict } from 'mixpanel-browser';

import { MIXPANEL_TOKEN as FALLBACK_TOKEN } from '../conf';

import { enrichOptions } from './eventsDataUtil';

const MIXPANEL_TOKEN = getEnvVariable('REACT_APP_MIXPANEL_TOKEN') || FALLBACK_TOKEN;

let isInitialized = false;
let initializationError: Error | null = null;

export const initMixpanel = (): void => {
  if (!MIXPANEL_TOKEN) {
    const error = new Error('Mixpanel token is missing');
    console.warn('Mixpanel token is missing! Check your configuration');
    initializationError = error;
    return;
  }

  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      autocapture: false,
      debug: process.env.NODE_ENV === 'development'
    });

    isInitialized = true;
    initializationError = null;
  } catch (error) {
    console.error('Failed to initialize Mixpanel:', error);
    initializationError = error as Error;
  }
};

export const isMixpanelInitialized = (): boolean => {
  return isInitialized && !initializationError;
};

export const resetMixpanelSession = (): void => {
  try {
    if (isMixpanelInitialized()) {
      mixpanel.reset();
    }
  } catch (error) {
    console.error('Failed to reset Mixpanel session:', error);
  }
};

export const trackMixpanelEvent = (eventName: string, options: Dict) => {
  try {
    if (!isMixpanelInitialized()) {
      console.warn('Mixpanel not available, skipping event tracking:', eventName);
      return;
    }

    const enrichedOptions = enrichOptions(options);
    mixpanel.track(eventName, enrichedOptions);
  } catch (error) {
    console.error('Failed to send Mixpanel event:', error);
  }
};